<template>
    <component :is="icon" :class="classList" :aria-label="icon" v-on="$listeners" />
</template>

<script>
import SvgIcons from './Icons/svg';
import CustomIcons from './Icons/custom';

export default {
    name: 'SrIcon',
    components: {
        ...SvgIcons,
        ...CustomIcons,
    },
    props: {
        icon: {
            type: String,
            required: true,
        },

        size: {
            type: String,
            default: 'm',
            validator(size) {
                return ['xxs', 'xs', 's', 'm', 'ml', 'l', 'xl', 'xxl'].includes(size);
            },
        },

        active: Boolean,
        disabled: Boolean,
    },

    computed: {
        classList() {
            const classes = ['sr-icon', `sr-icon-${this.size}`];
            if (this.active) {
                classes.push('sr-icon-active');
            }
            if (this.disabled) {
                classes.push('sr-icon-disabled');
            }

            return classes;
        },
    },
};
</script>
